import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "appliedFiltersContainer" }
const _hoisted_2 = {
  key: 0,
  class: "appliedFilters"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "appliedFilters"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, key, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        (_ctx.hasText(filter))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(filter.valueText) + " ", 1),
                _createElementVNode("button", {
                  class: "btn btn-icon",
                  onClick: ($event: any) => (_ctx.$emit('remove', key, filter.clear))
                }, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr088.svg" })
                ], 8, _hoisted_3)
              ])
            ]))
          : (_ctx.hasArrayOrValue(filter))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  (Array.isArray(filter.value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.value, (v, idx) => {
                          return (_openBlock(), _createElementBlock("span", { key: idx }, [
                            _createTextVNode(_toDisplayString(v), 1),
                            (filter.value.length !== idx + 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/"))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-icon",
                    onClick: ($event: any) => (_ctx.$emit('remove', key, filter.clear))
                  }, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr088.svg" })
                  ], 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}